<div class="th-menulevel modal">
  <div class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(2)">
    <span>{{ 'menus.add' | translate }} {{ 'menus.observation' | translate }}</span>
  </div>
  <div *ngIf="!isInOffline" class="ir-btn ir-btn--big th-btn-remove" (click)="selectMenu(1)">
    <span>{{ 'menus.delete' | translate }} {{ 'menus.plugin' | translate }}</span>
  </div>
  <div
    *ngIf="currentPerson?.isHost && isConnection"
    class="ir-btn ir-btn--big th-btn-menulevel"
    (click)="selectMenu(10)"
  >
    <span>{{ 'menus.edit-json' | translate }} </span>
  </div>
  <div *ngIf="isConnection && !isInOffline" class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(11)">
    <span>{{ 'menus.edit' | translate }} </span>
  </div>
</div>
